/* eslint-disable */
import React from 'react';

const GlNewNote = () => {
  return (
    <p className="text--gray text--regular pledge__info dg-new-note-text">
      <span className="text--darkBlue text--bold">Note: </span>
      Gold prices fluctuate daily, hence your final Gold Loan amount will be
      based on the maximum Loan To Value (LTV) of your gold jewellery appraised
      on that particular day along with the scheme you select.
      <br />
      <br />
      **Loan-To-Value (LTV) is calculated based on the purity of gold in the
      gold ornaments. It is also subject to change depending on the customer's
      location/MFL branch where the gold loan account is opened.
    </p>
  );
};

export default GlNewNote;
